import angular from 'angular';

import AddOffice from './addOffice';
import Financing from './financing';
import Profile from './profile';

import OfficesController from './officesController';
import OfficeDetailController from './officeDetailController';
import OfficesTableController from './officesTable/officesTableController';
import DeleteOfficeController from './deleteOffice/deleteOfficeController';
import OfficesFactory from './officesFactory';


import './header/detailHeader.scss'; // no controller
import './licensure/officeLicensure.scss'; // no controller

export default angular.module('app.accounts.offices', [AddOffice, Financing, Profile])
    .controller('OfficesController', OfficesController)
    .controller('OfficeDetailController', OfficeDetailController)
    .controller('OfficesTableController', OfficesTableController)
    .controller('DeleteOfficeController', DeleteOfficeController)
    .service('OfficesFactory', OfficesFactory)
    .run(($templateCache) => {
        $templateCache.put('app/accounts/offices/officeDetail.html', require('./officeDetail.html')); // eslint-disable-line global-require

        $templateCache.put('app/accounts/offices/officesTable/officesTable.html', require('./officesTable/officesTable.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/deleteOffice/deleteOffice.html', require('./deleteOffice/deleteOffice.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/header/detailHeader.html', require('./header/detailHeader.html')); // eslint-disable-line global-require

        $templateCache.put('app/accounts/offices/licensure/officeLicensure.html', require('./licensure/officeLicensure.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/licensure/viewLicensure.html', require('./licensure/viewLicensure.html')); // eslint-disable-line global-require
    })
    .name;




// WEBPACK FOOTER //
// ./src/app/accounts/offices/index.js